import { useState } from "react";
import { Container } from "reactstrap";
import All from "./All/All";
import Active from "./Active/Active";
import Deactivated from "./Deactivated/Deactivated";
import Ended from "./Ended/Ended";
import AddNewCoupon from "./AddNewCoupon/AddNewCoupon";
import WholesalerTabs from "../../../../components/WholesalerComponents/WholesalerTabs/WholesalerTabs";

const Coupons = () => {
  const tabs = ["All", "Active", "Deactivated", "Ended", "Add New Coupon"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", padding: "20px" }}>
      <h4 className="fw-semibold mb-2">Coupons</h4>
      <WholesalerTabs
        activeTab={activeTab}
        tabs={tabs}
        setActiveTab={setActiveTab}
      />
      <div className="mt-3" />

      {activeTab === "All" && <All />}
      {activeTab === "Active" && <Active />}
      {activeTab === "Deactivated" && <Deactivated />}
      {activeTab === "Ended" && <Ended />}
      {activeTab === "Add New Coupon" && <AddNewCoupon />}

    </div>
  );
};

export default Coupons;